import { http } from './config'
import authHeader from './auth-header';

export default {
    
    /**
     * Altera o status de um arquivo entre Ativo e Cancelado
     * @param {number} id - ID do arquivo
     * @param {string} novoStatus - Novo status do arquivo (Ativo ou Cancelado)
     * @returns {Promise} - Promise com o resultado da operação
     */
    alterarStatusArquivo: (id, novoStatus) => {
        return http.patch(`/ged/arquivos/${id}?novoStatus=${novoStatus}`, null, {
            headers: authHeader()
        });
    },
    
    /**
     * Busca arquivos com base nos filtros informados
     * @param {string} termo - Termo para busca
     * @param {string} empresas - Empresas separadas por vírgula
     * @param {string} categoria - Categoria do arquivo
     * @param {string} departamentos - Departamentos separados por vírgula
     * @returns {Promise} - Promise com o resultado da busca
     */
    buscarArquivos: (termo, empresas, categoria, departamentos) => {
        const params = {
            buscaArquivo: termo || '',
            empresas: empresas || '',
            categoria: categoria || '',
            departamentos: departamentos || ''
        };
        
        return http.get('/ged/busca', {
            params: params,
            headers: authHeader()
        });
    },
    
    /**
     * Obtém o conteúdo de um arquivo para download ou visualização
     * @param {string} arquivoExterno - Caminho do arquivo externo
     * @returns {Promise} - Promise com o conteúdo do arquivo em base64
     */
    downloadArquivo: (arquivoExterno) => {
        return http.get('/ged/download', {
            params: {
                arquivoExterno: arquivoExterno
            },
            headers: authHeader()
        });
    },
    
    /**
     * Envia um novo arquivo para o sistema
     * @param {FormData} formData - FormData contendo o arquivo e metadados
     * @returns {Promise} - Promise com o resultado do upload
     */
    uploadArquivo: (formData) => {
        return http.post('/ged/upload', formData, {
            headers: {
                ...authHeader(),
                'Content-Type': 'multipart/form-data'
            }
        });
    },
    
    /**
     * Lista categorias disponíveis para arquivos
     * @returns {Promise} - Promise com a lista de categorias
     */
    listarCategorias: () => {
        return http.get('/ged/categorias', {
            headers: authHeader()
        });
    },
    
    /**
     * Lista departamentos disponíveis para arquivos
     * @returns {Promise} - Promise com a lista de departamentos
     */
    listarDepartamentos: () => {
        return http.get('/ged/departamentos', {
            headers: authHeader()
        });
    }
};
